import React from "react";
import "./TitleScreen.css";

export default function TitleScreen() {
  return (
    <div className="title-screen">
      <h1>Re:Wand</h1>
      <div className="hint">
        <span>
          DRAG the
          <span className="hint-player">Wand</span>
          Card (left) to the
          <span className="hint-reward">Reward</span>
          Card (right) to start the game
        </span>
      </div>
    </div>
  );
}
